import { Component } from 'preact'
import { connect } from 'preact-redux'
import cx from 'classnames'

import {
  setTypeGift,
  setTypeSelf,
  setTypeUpgrade,
  setTypeCompany,
} from './newPaybarActions'

import getAvailableTabs from './getAvailableTabs'
import NewPaybarTabsSwitcher from './newPaybarTabsSwitcher'

const setTypeSelfSub = setTypeSelf.bind(null, { typeInUrl: 'self:sub' })

class NewPaybarTabs extends Component {
  regularSwitcherProps(name) {
    const product = this.props.product
    const tabs = `newPaybar.tabs.${product}`
    const capitalizedName = name
      .split(':')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('')

    const text = I18n.t(`${tabs}.${name}`)
    const mobileText = I18n.t(`${tabs}.mobile${capitalizedName}`, { defaults: { message: text } })

    return {
      text,
      mobileText,
      isActive: this.props.type === name || this.props.typeInUrl === name,
      onClick: this.props[`setType${capitalizedName}`],
      isUpgrade: name === 'upgrade',
    }
  }

  render(props) {
    const tabs = getAvailableTabs(props)

    return (
      <div className={ cx('newPaybarTabs', `device ${props.device}`) }>
          <div className="newPaybarTabs-switchers">
            { tabs.includes('upgrade') &&
              <NewPaybarTabsSwitcher { ...this.regularSwitcherProps('upgrade') } />
            }

            { tabs.includes('sub') &&
              <NewPaybarTabsSwitcher { ...this.regularSwitcherProps('sub') } />
            }

            { (tabs.includes('self')) &&
              <NewPaybarTabsSwitcher { ...this.regularSwitcherProps('self') } />
            }

            { (tabs.includes('self:sub')) &&
              <NewPaybarTabsSwitcher { ...this.regularSwitcherProps('self:sub') } />
            }

            { tabs.includes('gift') &&
              <NewPaybarTabsSwitcher { ...this.regularSwitcherProps('gift') } />
            }

            { tabs.includes('company') &&
              <NewPaybarTabsSwitcher { ...this.regularSwitcherProps('company') } />
            }
          </div>
      </div>
    )
  }
}

const mapStateToProps = ({ newPaybar }) => {
  return {
    prices: newPaybar.prices,
    product: newPaybar.product,
    type: newPaybar.type,
    typeInUrl: newPaybar.typeInUrl,
    subscription: newPaybar.subscription,
    hasCompanyTabOnly: newPaybar.hasCompanyTabOnly,
  }
}

const mapDispatchToProps = {
  setTypeGift,
  setTypeSelf,
  setTypeUpgrade,
  setTypeCompany,
  setTypeSelfSub,
}

export default connect(mapStateToProps, mapDispatchToProps)(NewPaybarTabs)
